// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: rgb(6, 93, 151);
}

.product_grid{
  flex-wrap: wrap;
}

.container {
  margin: 0 !important;
  padding: 0 !important;
}

.buttonstyle {
  border-radius: .5em;
  background-color: rgb(255, 255, 255);
}
`, "",{"version":3,"sources":["webpack://./src/pages/home.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC","sourcesContent":["body {\n  background-color: rgb(6, 93, 151);\n}\n\n.product_grid{\n  flex-wrap: wrap;\n}\n\n.container {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.buttonstyle {\n  border-radius: .5em;\n  background-color: rgb(255, 255, 255);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
